
import { Component, Vue } from "vue-property-decorator";
import { QRScannerModule } from "@/store/qrscanner";
import { QrTicketScanRequest } from "@/store/qrscanner/types";
import { AuthModule } from "@/store/auth";
import VueCompositionAPI from "@vue/composition-api";
Vue.use(VueCompositionAPI);
import { ref } from "@vue/composition-api";

@Component
export default class TicketScanCamera extends Vue {
  public dialog = true;
  public qrContent: string | undefined;
  public error = false;
  public loading = false;
  public camera = "auto";
  public showScanConfirmation = false;
  public userPaused = false;
  public active = ref(false);

  get currentEventType(): unknown {
    return AuthModule.currentEventInfo.eventType;
  }

  // eslint-disable-next-line
  async onInit(promise: any): Promise<void> {
    this.loading = true;
    try {
      await promise;
    } catch (error: any) {
      if (error.name === "NotAllowedError") {
        this.$notify({
          group: "tickets",
          type: "error",
          title: "Ticket Scanner",
          text: `You need to grant camera access permisson. Redirecting to Form.`,
        });
      } else if (error.name === "NotFoundError") {
        this.$notify({
          group: "tickets",
          type: "error",
          title: "Ticket Scanner",
          text: `ERROR: no camera on this device. Redirecting to Form.`,
        });
      } else if (error.name === "NotSupportedError") {
        this.$notify({
          group: "tickets",
          type: "error",
          title: "Ticket Scanner",
          text: `ERROR: secure context required (HTTPS, localhost). Redirecting to Form.`,
        });
      } else if (error.name === "NotReadableError") {
        this.$notify({
          group: "tickets",
          type: "error",
          title: "Ticket Scanner",
          text: `ERROR: is the camera already in use? Redirecting to Form.`,
        });
      } else if (error.name === "OverconstrainedError") {
        this.$notify({
          group: "tickets",
          type: "error",
          title: "Ticket Scanner",
          text: `ERROR: installed cameras are not suitable. Redirecting to Form.`,
        });
      } else if (error.name === "StreamApiNotSupportedError") {
        this.$notify({
          group: "tickets",
          type: "error",
          title: "Ticket Scanner",
          text: `ERROR: Stream API is not supported in this browser. Redirecting to Form.`,
        });
      }
      this.$emit("errorCamera");
      this.$emit("errorEvent");

      this.showScanConfirmation = this.camera === "off";
    } finally {
      this.loading = false;
    }
  }

  public toggleCamera(): void {
    if (this.camera === "auto" || this.camera !== "off") {
      this.userPaused = true;
      this.camera = "off";
    } else {
      this.userPaused = false;
      this.camera = "auto";
      this.activate();
    }
  }

  public unpause(): void {
    this.userPaused = false;
    this.camera = "auto";
    this.activate();
  }
  public pause(): void {
    this.camera = "off";
  }

  public activate = async () => {
    this.active.value = true;
    setTimeout(() => {
      this.active.value = false;
    }, 50);
  };

  public async onDecode(decodedString: string): Promise<void> {
    console.log(decodedString);
    if (
      decodedString.indexOf("scanticket?id=") >= 0 ||
      decodedString.split("|").length === 3
    ) {
      if (decodedString) {
        this.qrContent = decodedString;
        if (
          "Workshop|Open|Leadership|Training"
            .toLowerCase()
            .indexOf((this.currentEventType + "").toLowerCase()) > -1
        ) {
          await this.scanWorkShopTicket(
            this.qrContent,
            (this.currentEventType + "").toLowerCase()
          );
        } else {
          // TODO Mandar msg de error
          this.pause();
          this.$notify({
            group: "tickets",
            type: "error",
            title: "Ticket Scanner",
            text: "Event is not ready to use the QR Scanner!",
          });
          // this.$emit("successEvent");
          this.$emit("errorEvent");
          this.unpause();
        }
      }
    } else {
      this.pause();
      this.$notify({
        group: "tickets",
        type: "error",
        title: "INVALIR QR",
        text: "INVALIR QR FORMAT PLEASE SCANN A VALID QR",
      });
      this.$emit("errorEvent");
      this.unpause();
    }
  }

  public async scanWorkShopTicket(
    url: string,
    eventType: string
  ): Promise<void> {
    this.pause();
    var params = url.indexOf("|");
    if (params > 1) {
      const params = url.split("|");
      if (params[0] != AuthModule.currentEventID) {
        this.error = true;
        this.$notify({
          group: "tickets",
          type: "error",
          title: "Ticket Scanner",
          text: "El boleto es de un evento diferente",
        });
      } else {
        var data = {
          eventid: params[0],
          attendancekey: params[1],
          orderid: params[2],
        };
        await QRScannerModule.ScanTicketQr({ data });
        const currentSuccessStatus = QRScannerModule.currentSuccessStatus;
        if (currentSuccessStatus === true) {
          this.error = false;
          this.$notify({
            group: "tickets",
            type: "success",
            title: "Ticket Scanner",
            text: "Scan is successful!",
          });
          this.$emit("successEvent");
        } else {
          this.error = true;
          this.$notify({
            group: "tickets",
            type: "error",
            title: "Ticket Scanner",
            text: QRScannerModule.error,
          });
        }
      }
    } else {
      await QRScannerModule.ScanTicket({ url, eventType });

      const currentSuccessStatus = QRScannerModule.currentSuccessStatus;

      if (currentSuccessStatus === true) {
        this.error = false;
        this.$notify({
          group: "tickets",
          type: "success",
          title: "Ticket Scanner",
          text: "Scan is successful!",
        });
        this.$emit("successEvent");
      } else {
        const currentErrorMessage = QRScannerModule.currentErrorMessage;

        console.log(currentErrorMessage);
        if (
          currentErrorMessage ===
          "This ticket has been scanned but is registered for this event you may enter this event."
        ) {
          this.error = false;
          this.$notify({
            group: "tickets",
            type: "warn",
            title: "Ticket Scanner",
            text: `Scan is successful but with warning! ${currentErrorMessage}`,
          });
          this.$emit("successEvent");
        } else {
          this.error = true;
          this.$notify({
            group: "tickets",
            type: "error",
            title: "Ticket Scanner",
            text: `Scan is unsuccessful! ${currentErrorMessage}`,
          });
        }
      }
    }
    this.unpause();
  }
}
